import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name", "rename", "label"];
import { useEffect, memo } from 'react';
import { Input, useStore } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Username = /*#__PURE__*/memo(props => {
  var {
      keyname = 'username',
      name,
      rename,
      label = 'Username:'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var {
    dispatch
  } = useStore();
  var key = keyname || name;
  useEffect(() => dispatch({
    ["$" + key]: label
  }), [label]);
  return /*#__PURE__*/_jsx(Input, _extends({
    placeholder: "Username",
    spellCheck: false,
    index: 1
  }, elmProps, {
    name: name || rename || keyname,
    keyname: key
  }));
});
Username.displayName = 'BaseLogin.Username';